/* ========================================================================
 *  module feedback
 * ========================================================================
*/
FD.LINK8D = (function ($, me) {
    'use strict';

    var child = me.LINK8D || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_8D = '/8D//Modules/';

    var MESSAGE_CONTAINER_ELEM = '[data-modalmessage="true"]';
    var PARENT_ELEM = '[data-parent="true"]';
    var MODAL_ELEM = '#LINK8D_MODAL';

    var modal;
    var messageModalContainer = $(MESSAGE_CONTAINER_ELEM);
    var modalCallback = null;
    var updateCallback = null;
    var idList = [];
    var allowMultiple = false;
    var searchTerm = "";
    var status = 1; // All

    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {

        SEARCH_TEXT: 10,
        SEARCH_STATUS: 11,

        CHECK_8D: 20
    };


    /* ========================================================================
     *  object functions
     * ========================================================================
    */




    /* ========================================================================
     *  initial setup
     * ========================================================================
    */
    

    //  load modal
    function getLink8DModal() {
        if (me.getModalLock()) {
            return;
        }

        me.setModalLock(true);
        var options = {
            params: {
                idList: idList,
                allowMultiple: allowMultiple
            },
            url: URL_8D + 'GetLink8DModal',
            callback: afterData,
            ishtml: true,
            cancelprevious: true
        };
        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;

            $('body').append(result);

            modal = $(MODAL_ELEM);

            modal.off().on('shown.bs.modal', function () {
                me.setToolTipDestroy();
                me.CONTROL.setButton(true, MODAL_ELEM);
                me.CONTROL.setSelect(true, MODAL_ELEM);
                me.CONTROL.setCheckBox(true, MODAL_ELEM);
                me.CONTROL.setText(true, MODAL_ELEM);
                me.CONTROL.setTableInPage(modal.find('#LINK_EIGHTD_TABLE'));
                me.CONTROL.setScroll(MODAL_ELEM);
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                if (modalCallback && typeof modalCallback === 'function') {
                    modalCallback(idList);
                }
                $(MODAL_ELEM).remove();
            }).modal('show');

            messageModalContainer = $(MESSAGE_CONTAINER_ELEM);
            messageModalContainer = me.CONTROL.setMessageContainer(MESSAGE_CONTAINER_ELEM);
        }
    }


    /* ========================================================================
     *  Return Functions
     * ========================================================================
    */


    function search8DList(data) {
        messageModalContainer.setSpinner();
        if (data.tag === tag.SEARCH_TEXT) {
            searchTerm = data.value;
        } else {
            status = +data.value;
        }

        var options = {
            url: URL_8D + "RefreshLinked8DList",
            params: {
                idList: idList,
                searchTerm: searchTerm,
                status: status
            },
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                $(MODAL_ELEM).find('#LINK_EIGHTD_ROWDATA').html(result);
                me.CONTROL.setCheckBox(true, MODAL_ELEM);
                messageModalContainer.setSpinnerOff();
            } else {
                messageModalContainer.setMessage();
            }
        }
    }


    /* ========================================================================
     *  CRUD Functions
     * ========================================================================
    */



    function handle8DCheck(data) {
        messageModalContainer.setSpinner();
        if (allowMultiple) {
            if (data.value) {
                idList.push(+data.parentid);
            } else {
                idList.splice(idList.indexOf(+data.parentid), 1);
            }

            if (updateCallback && typeof updateCallback === 'function') {
                updateCallback(idList, +data.parentid);
            }
        } else {
            if (idList.length > 0) {
                $(MODAL_ELEM).find('[data-parentid="' + idList[0] + '"]').find('[data-fd="checkbox"]').updateCheckbox({ value: false });
            }
            idList = data.value ? [+data.parentid] : [];

            if (updateCallback && typeof updateCallback === 'function') {
                updateCallback(idList);
            }
        }
        messageModalContainer.setSpinnerOff();
    }




    /* ========================================================================
     *  page init
     * ========================================================================
    */


    child.init = function () { };

    // Display edit project modal
    // projectID: ID of the project to edit
    // callback: call this function after the modal closes if the user made any changes. It doesn't pass any parameters
    child.loadLink8DModal = function (_8DIDList, allowMultipleSelections, functionOnUpdate, functionOnHide) {
        modalCallback = functionOnHide;
        updateCallback = functionOnUpdate;
        idList = _8DIDList || [];
        allowMultiple = allowMultipleSelections || false;

        // ensure all IDs are integers and not strings
        for (var x = 0; x < _8DIDList.length; x++) {
            idList[x] = +idList[x];
        }
        getLink8DModal();
    };



    //   after control event
    child.getAfterControlEvent = function (data) {
        var result = data;

        switch (result.tag) {
            case tag.SEARCH_TEXT:
            case tag.SEARCH_STATUS:
                search8DList(result);
                break;
            case tag.CHECK_8D:
                handle8DCheck(result);
                break;
        }
    };

    return child;
}(jQuery, FD));



